import ExportModal, { StateProps } from 'common/components/ExportModal';
import { connect } from 'react-redux';
import { AppState, QueryMetaSuccess } from '../../redux/store';
import { querySuccess } from '../../lib/selectors';
import { QueryStatus } from 'common/explore_grid/types';
import { none, some } from 'ts-option';
import { buildSucceeded } from '../../lib/feature-flag-helpers';

const mapStateToProps = (state: AppState): StateProps => {
  const queryResult = querySuccess(state.query.queryResult).flatMap((success) => {
    const cr = success.compiled.orUndefined;
    const ar = success.analyzed.orUndefined;
    if (cr || ar) {
      return some(buildSucceeded(cr, ar));
    } else {
      return none;
    }
  });
  const queryMeta = querySuccess(state.query.queryResult)
    .map((qr) => qr.meta)
    .flatMap<QueryMetaSuccess>((meta) => {
      return meta.type == QueryStatus.QUERY_META_SUCCESS ? some(meta) : none;
    });
  return {
    query: queryResult,
    meta: queryMeta,
    view: state.view,
    clientContextVariables: state.clientContextInfo.variables
  };
};

export default connect(mapStateToProps)(ExportModal);
